// Complete Translation System for PM Home Remodeling
export const translations = {
  'pt-BR': {
    // Navigation
    home: 'Home',
    laborBill: 'Labor Bill', 
    payroll: 'Payroll',
    admin: 'Admin',
    reports: 'Weekly Report',
    arbitration: 'Arbitration Files',
    support: 'Suporte',
    
    // Common Actions
    save: 'Salvar',
    cancel: 'Cancelar',
    delete: 'Deletar',
    edit: 'Editar',
    view: 'Ver',
    download: 'Download',
    upload: 'Upload',
    loading: 'Carregando...',
    search: 'Buscar',
    close: 'Fechar',
    confirm: 'Confirmar',
    create: 'Criar',
    update: 'Atualizar',
    add: 'Adicionar',
    remove: 'Remover',
    
    // Login & Auth
    username: 'Nome de Usuário',
    password: 'Senha',
    signIn: 'Entrar',
    signOut: 'Sair',
    forgotPassword: 'Esqueceu sua senha?',
    userSettings: 'Configurações do Usuário',
    changePassword: 'Redefinir Senha',
    
    // Home & Dashboard
    welcome: 'Olá',
    supportTickets: 'Tickets de Suporte',
    recentTickets: 'Tickets Recentes',
    open: 'Abertos',
    pending: 'Pendentes', 
    resolved: 'Resolvidos',
    weeklyReportSummary: 'Resumo Relatório Semanal',
    lastLaborBills: 'Últimos Labor Bills',
    
    // Labor Bill Creation/Edit
    laborBills: 'Labor Bills',
    createNew: 'Criar Novo',
    jobName: 'Nome do Trabalho',
    orderNumber: 'Número da Ordem',
    installDate: 'Data de Instalação',
    totalWindows: 'Total de Janelas',
    totalDoors: 'Total de Portas',
    notes: 'Observações',
    draftSaved: 'Rascunho salvo!',
    sendEmail: 'Enviar Email',
    paid: 'Pago',
    markAsPaid: 'Marcar como Pago',
    transfer: 'Transferir',
    moveTo: 'Mover para',
    
    // Team Leaders & Documents
    personalInfo: 'Informações Pessoais',
    manageProfile: 'Gerenciar Perfil',
    fullName: 'Nome Completo',
    email: 'Email',
    phone: 'Telefone',
    address: 'Endereço',
    position: 'Posição/Cargo',
    documents: 'Documentos',
    driverLicense: 'Driver License',
    leadCertificate: 'Certificado de Lead',
    backgroundCheck: 'Background Check',
    
    // Arbitration Files
    arbitrationFiles: 'Arbitration Files',
    helperName: 'Nome do Helper',
    digitalSignature: 'Assinatura Digital',
    date: 'Data',
    signAndSave: 'Assinar e Salvar',
    clearSignature: 'Limpar Assinatura',
    newArbitrationFile: 'Novo Arbitration File Helper',
    sendToSupervisor: 'Enviar para Supervisor',
    
    // Payroll System
    processExcel: 'Processar Excel',
    weekEndingDate: 'Week Ending Date',
    excelFile: 'Arquivo Excel',
    teamConfiguration: 'Configuração de Equipes',
    reports: 'Relatórios',
    uploadExcel: 'Upload Excel',
    manageClients: 'Gerenciar Clientes',
    
    // Admin Section
    users: 'Usuários',
    teamLeaders: 'Team Leaders',
    systemSettings: 'Sistema',
    emailSettings: 'Emails',
    import: 'Importar',
    migration: 'Migração',
    emptyTrash: 'Esvaziar Lixeira',
    
    // Status & Messages
    success: 'Sucesso',
    error: 'Erro',
    warning: 'Aviso',
    info: 'Informação',
    noData: 'Nenhum dado encontrado',
    confirmDelete: 'Confirmar exclusão',
    
    // Time & Dates  
    today: 'Hoje',
    yesterday: 'Ontem',
    thisWeek: 'Esta Semana',
    lastWeek: 'Semana Passada',
    created: 'Criado',
    updated: 'Atualizado',
    
    // Financial Terms
    totalLabor: 'Total Labor',
    totalFinal: 'Total Final', 
    expenses: 'Despesas',
    profit: 'Lucro',
    total: 'Total',
    weeklyReport: 'Weekly Report',
    
    // Form Labels
    firstName: 'Primeiro Nome',
    lastName: 'Sobrenome',
    dateOfBirth: 'Data de Nascimento',
    hireDate: 'Data de Contratação',
    
    // Table Headers
    jobs: 'Jobs',
    customer: 'Cliente',
    labor: 'Labor',
    final: 'Final',
    
    // Common Phrases
    pleaseWait: 'Aguarde...',
    processing: 'Processando...',
    saving: 'Salvando...',
    sending: 'Enviando...',
    loading: 'Carregando...',
    uploading: 'Uploading...',
    
    // Validation Messages
    required: 'Campo obrigatório',
    invalidEmail: 'Email inválido',
    passwordMismatch: 'Senhas não coincidem',
    
    // Success Messages  
    saveSuccess: 'Salvo com sucesso!',
    updateSuccess: 'Atualizado com sucesso!',
    deleteSuccess: 'Deletado com sucesso!',
    emailSent: 'Email enviado!',
    
    // Error Messages
    saveError: 'Erro ao salvar',
    loadError: 'Erro ao carregar',
    deleteError: 'Erro ao deletar',
    networkError: 'Erro de conexão'
  },
  'en-US': {
    // Navigation
    home: 'Home',
    laborBill: 'Labor Bill',
    payroll: 'Payroll', 
    admin: 'Admin',
    reports: 'Weekly Report',
    arbitration: 'Arbitration Files',
    support: 'Support',
    
    // Common Actions
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    download: 'Download',
    upload: 'Upload',
    loading: 'Loading...',
    search: 'Search',
    close: 'Close',
    confirm: 'Confirm',
    create: 'Create',
    update: 'Update',
    add: 'Add',
    remove: 'Remove',
    
    // Login & Auth
    username: 'Username',
    password: 'Password', 
    signIn: 'Sign In',
    signOut: 'Sign Out',
    forgotPassword: 'Forgot your password?',
    userSettings: 'User Settings',
    changePassword: 'Change Password',
    
    // Home & Dashboard
    welcome: 'Hello',
    supportTickets: 'Support Tickets',
    recentTickets: 'Recent Tickets',
    open: 'Open',
    pending: 'Pending',
    resolved: 'Resolved', 
    weeklyReportSummary: 'Weekly Report Summary',
    lastLaborBills: 'Recent Labor Bills',
    
    // Labor Bill Creation/Edit
    laborBills: 'Labor Bills',
    createNew: 'Create New',
    jobName: 'Job Name',
    orderNumber: 'Order Number',
    installDate: 'Install Date',
    totalWindows: 'Total Windows',
    totalDoors: 'Total Doors',
    notes: 'Notes',
    draftSaved: 'Draft saved!',
    sendEmail: 'Send Email',
    paid: 'Paid',
    markAsPaid: 'Mark as Paid', 
    transfer: 'Transfer',
    moveTo: 'Move to',
    
    // Team Leaders & Documents
    personalInfo: 'Personal Information',
    manageProfile: 'Manage Profile',
    fullName: 'Full Name',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    position: 'Position',
    documents: 'Documents',
    driverLicense: 'Driver License',
    leadCertificate: 'Lead Certificate',
    backgroundCheck: 'Background Check',
    
    // Arbitration Files
    arbitrationFiles: 'Arbitration Files',
    helperName: 'Helper Name',
    digitalSignature: 'Digital Signature',
    date: 'Date',
    signAndSave: 'Sign and Save',
    clearSignature: 'Clear Signature',
    newArbitrationFile: 'New Arbitration File Helper',
    sendToSupervisor: 'Send to Supervisor',
    
    // Payroll System
    processExcel: 'Process Excel',
    weekEndingDate: 'Week Ending Date',
    excelFile: 'Excel File',
    teamConfiguration: 'Team Configuration',
    reports: 'Reports',
    uploadExcel: 'Upload Excel',
    manageClients: 'Manage Clients',
    
    // Admin Section
    users: 'Users',
    teamLeaders: 'Team Leaders',
    systemSettings: 'System',
    emailSettings: 'Emails',
    import: 'Import',
    migration: 'Migration',
    emptyTrash: 'Empty Trash',
    
    // Status & Messages
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Information',
    noData: 'No data found',
    confirmDelete: 'Confirm deletion',
    
    // Time & Dates
    today: 'Today',
    yesterday: 'Yesterday',
    thisWeek: 'This Week',
    lastWeek: 'Last Week',
    created: 'Created',
    updated: 'Updated',
    
    // Financial Terms
    totalLabor: 'Total Labor',
    totalFinal: 'Total Final',
    expenses: 'Expenses',
    profit: 'Profit',
    total: 'Total',
    weeklyReport: 'Weekly Report',
    
    // Form Labels
    firstName: 'First Name',
    lastName: 'Last Name',
    dateOfBirth: 'Date of Birth',
    hireDate: 'Hire Date',
    
    // Table Headers
    jobs: 'Jobs',
    customer: 'Customer',
    labor: 'Labor',
    final: 'Final',
    
    // Common Phrases
    pleaseWait: 'Please wait...',
    processing: 'Processing...',
    saving: 'Saving...',
    sending: 'Sending...',
    loading: 'Loading...',
    uploading: 'Uploading...',
    
    // Validation Messages
    required: 'Required field',
    invalidEmail: 'Invalid email',
    passwordMismatch: 'Passwords do not match',
    
    // Success Messages
    saveSuccess: 'Saved successfully!',
    updateSuccess: 'Updated successfully!',
    deleteSuccess: 'Deleted successfully!', 
    emailSent: 'Email sent!',
    
    // Error Messages
    saveError: 'Save error',
    loadError: 'Load error',
    deleteError: 'Delete error',
    networkError: 'Network error'
  }
};

// Helper to get translation with fallback
export const getTranslation = (language, key, fallback = key) => {
  return translations[language]?.[key] || fallback;
};